import React, { useEffect, useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import Update_MaleForm from "./Update_MaleForm";
import Update_Female_Details from "./Update_Female_Details";
import { useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// import { useSample } from "../context/SampleContext";

function Update_Male_Details() {
    const sampleCode = useSelector((state) => state.sample.code);

    const [center_list, setCenter_list] = useState([]);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("male");

    const { male_id } = useParams();
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const { user: loggedUser } = useAuth();

    

    const [maleForm, setMaleForm] = useState({

        CRN_No: "",
        Patient_Name: "",
        sample_id: "",
        Age: "",
        dob: "",
        sample_master_id: null,
        pmid: null,
        Education: "",
        Occupation: "",
        Smoking: "1",
        Chewing_Tobacco: "1",
        Alcohol: "1",
        Diabetes: "0",
        Hypertension: "0",
        Genetic_Conditions: "",
        Mumps: "0",
        Trauma: "0",
        Surgeries: "0",
        Hernia: "0",
        Undescended_Testes: "0",
        Varicocele: "0",
        Vasectomy: "0",
        STD_Genital_Discharges: "0",
        Others: "",
        General_Examination: "",
        Local_Examination: "",
        Blood_Group: "",
        Blood_Sugar_R: "",
        HIV: "0",
        HBsAg: "0",
        Hb_Electrophoresis: "0",
        USG_Doppler: "",
        Karyotyping_Analysis: "",
        Testicular_Biopsy: "",
        Urologist_Opinion: "",
        Others_any: "",
        Date_of_Sample: "",
        Ejaculatory_Abstinence: "",
        Semen_Volume: "",
        Color: "",
        Appearance: "", Liquifcation_Time: "",

        Viscosity: "",
        pH: "",
        Semen_Concentration: "",
        Total_Sperm_Count: "",
        Progressive_Motility_Rate: "",
        Count_Motile_Sperm: "",
        NonP_Motility: "",
        Total_Motility: "",
        Total_NP_Motile_Sperm: "",
        Vitality: "",
        Normal_Sperm_Morphology: "",
        Abnormal_Heads: "",
        Abnormal_NandM: "",
        Abnormal_Tail: "",
        Extra_cytoplasmic: "",
        Qualitative_Fructose: "",
        Aggregation: "",
        Agglutination: "",
        Round_Cells: "",
        Epithelial_Cells: "",
        Other_Cells: "",
        Other_Remarks: "",
        center_code: "",
        procedure: "",
        cycle: "",
        donor_sperm: "",
        serial_no: "",
        sample_generated: "",

        execfile_dysfunction: "0",
        pre_mature_ejaculation: "0",

        Blood_Sugar_F: "",
        Blood_Sugar_PP: "",
        Semen_Concentration_unit: "",
        Progressive_Motility_unit: "",

        Liquifcation_Remark: "",
        Hb_Remark: "",
        ag_Remark: "",
        RSA_Report: "",
        Diabetes_Type: "",
        Diabetes_Duration: "",
        Hypertension_Duration: "",

        Immotile: "",

        ALT: "",
        ALP: "",
        AST: "",
        AST_ALT: "",
        GTT: "",
        Total_Bilirubin: "",
        Direct_Bilirubin: "",
        Indirect_Bilirubin: "",
        Total_Plastma_Protein: "",
        Albumin: "",
        Globulin: "",
        Albumin_Globulin_Ratio: "",
        Liver_Test_remark: "",

        Total_Cholesterol: "",
        LDL_Cholesterol: "",
        HDL_Cholesterol: "",
        VLDL_Cholesterol: "",
        Triglycerides: "",
        Total_cholesterol_HDL_ratio: "",
        LDL_to_HDL_ratio: "",
        Non_HDL_cholesterol: "",
        Lipid_Profile_remark: "",

        Total_Body_Water: "",
        Protein: "",
        Minerals: "",
        Body_Fat_Mass: "",
        Soft_Lean_Mass: "",
        Fat_Free_Mass: "",
        Body_Weight: "",
        Height: "",
        Body_Composition_remark: "",

        Weight: "",
        Skeletal_Muscle_Mass: "",
        Body_Fat_Mass_muscle: "",
        Body_Fat_Percent: "",
        Body_muscle_remark: "",

        BMI_Obesity: "",
        Percent_Body_Fat: "",
        obesity_remark: "",

        Right_Arm_Lean_Mass_kg: "",
        Right_Arm_Lean_Mass_percent: "",
        Right_Arm_ECW_Ratio: "",
        Left_Arm_Lean_Mass_kg: "",
        Left_Arm_Lean_Mass_percent: "",

        Left_Arm_ECW_Ratio: "",
        Trunk_Lean_Mass_kg: "",
        Trunk_Lean_Mass_percent: "",
        Trunk_ECW_Ratio: "",
        Right_Leg_Lean_Mass_kg: "",
        Right_Leg_Lean_Mass_percent: "",
        Right_Leg_ECW_Ratio: "",
        Left_Leg_Lean_Mass_kg: "",
        Left_Leg_Lean_Mass_percent: "",
        Left_Leg_ECW_Ratio: "",
        Segmental_remark: "",

        Right_Arm_Fat_Mass_kg: "",
        Right_Arm_Fat_Mass_percent: "",
        Left_Arm_Fat_Mass_kg: "",
        Left_Arm_Fat_Mass_percent: "",
        Trunk_Fat_Mass_kg: "",
        Trunk_Fat_Mass_percent: "",
        Right_Leg_Fat_Mass_kg: "",
        Right_Leg_Fat_Mass_percent: "",
        Left_Leg_Fat_Mass_kg: "",
        Left_Leg_Fat_Mass_percent: "",
        Segmental_fat_remark: "",

        Semen_Concentration_post: "",
        Total_Sperm_Count_post: "",
        Progressive_Motility_Rate_post: "",
        NonP_Motility_post: "",
        Immotile_post: "",
        Total_Motility_post: "",
        Normal_Sperm_Morphology_post: "",
        Abnormal_Heads_post: "",
        Abnormal_NandM_post: "",
        Abnormal_Tail_post: "",
        Extra_cytoplasmic_post: ""


    });
    const [femaleForm, setFemaleForm] = useState({

        pfid: null,
        CRN_No: "",
        Patient_Name: "",
        sample_id: "",
        Infertility_Reg_no: "",
        Age: "",
        dob: "",
        reg_date: "",
        address: "",
        Education: "",
        Occupation: "",
        refrred_by: "",
        Drug_Allergy: "",

        Married_Since: "",
        Infertility_Duration: "",
        Primary_Infertility: "",
        Secondary_Infertility: "",
        Other_Remarks: "",

        Age_at_Menarche: "",
        Day_of_MC: "",
        Previous_Cycle: "",
        Last_MC: "",
        Menstrual_Loss: "",
        Dysmenorrhea: "0",
        Postcoital_Bleeding: "0",
        Intermenstrual_Bleeding: "0",
        Menstural_Remarks: "",

        Intercourse_type: "",
        Intercourse_Frequency: "",
        Dyspareunia: "0",
        Erectile_Dysfunction: "0",
        Premature_Ejaculation: "0",
        Sexual_Remarks: "",

        Hirsutism: "0",
        Acanthosis_Nigricans: "0",
        Galactorrhoea: "0",
        Rubella_Vaccination: "0",
        Consanguineous_Marriage: "0",
        Contraceptive_Method: "",
        History_Remarks: "",

        Hypertension: "0",
        Medication_Hypertension: "",
        Diabetes: "0",
        Medication_Diabetes: "",
        Thyroid: "0",
        Medication_Thyroid: "",
        Cardiac_Disease: "0",
        Drugs_Cardiac_Disease: "",
        Medication_Cardiac_Disease: "",
        Medical_Remarks: "",

        Surgical_History: "",
        Family_History: "",

        Ovulation_Induction_Drugs: "",
        IUI: "",
        Prior_IVF: "",
        Treatment_Remarks: "",

        Height: "",
        Weight: "",
        BMI: "",
        Waist_Hip_Ratio: "",
        Blood_Pressure: "",
        Respiratory_System_Examination: "",
        CVS_Examination: "",
        Breast_Examination: "",
        Local_Examination: "",
        Per_Abdomen_Exam: "",
        Per_Speculum_Exam: "",
        Per_Vaginal_Exam: "",

        Blood_Group: "",
        CBC: "", Blood_Sugar_R: "",

        HbA1C: "",
        Hb_Electrophoresis: "",
        TORCH: "",
        Thrombophilia_Profile: "",
        Cervical_Smear: "",
        Karyotyping: "",
        Karyotyping_Wife: "",
        HIV: "0",
        HCV: "0",
        HBsAg: "0",
        HSG: "",



        female_Remark: "",
        Blood_Pressure_DBP: "",
        VDRL_Aldo: "",
        Obstetric_History: "",
        investigation_remark: "",

        Mid_cycle_Endometrial_Thickness: "",
        Ultrasound_Findings: "",
        Hystero_laparoscopy_Findings: ""
    });



    const [maleHormonalRows, setMaleHormonalRows] = useState([
        {
            assay_date: "",
            FSH: "",
            LH: "",
            Testosterone: "",
            Prolactin: "",
            FT4: "",
            FT3: "",
            TSH: ""
        }
    ]);

    const [femaleHormonalRows, setFemaleHormonalRows] = useState([
        {
            // assay_date: "",
            // AMH: "",
            // TSH: "",
            // Prolactin: "",
            AMH: "",
            FSH: "",
            LH: "",
            Estradiol: "",
            Progesterone: "",
            TSH: "",
            Prolactin: "",
        }
    ]);

    const handleMaleChange = (e) => {
        const { name, value, type } = e.target;

        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }
        setMaleForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // For Female_Details
    const handleFemaleChange = (e) => {
        const { name, value, type } = e.target;

        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }
        setFemaleForm(prev => ({
            ...prev,
            [name]: value
        }));
    };
    /////////////////////////////////////////////start validations//////////////////
    const [isMaleAgeManual, setIsMaleAgeManual] = useState(false);
    const [isFemaleAgeManual, setIsFemaleAgeManual] = useState(false);

    const handleMaleDobChange = (dob) => {
        let age = "";

        if (dob) {
            const birthDate = new Date(dob);
            const today = new Date();
            age = today.getFullYear() - birthDate.getFullYear();

            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
        }
        setIsMaleAgeManual(false);
        setMaleForm(prev => ({
            ...prev,
            dob,
            Age: age
        }));
    };

    const handleFemaleDobChange = (dob) => {
        let age = "";

        if (dob) {
            const birthDate = new Date(dob);
            const today = new Date();
            age = today.getFullYear() - birthDate.getFullYear();

            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
        }
        setIsFemaleAgeManual(false);
        setFemaleForm(prev => ({
            ...prev,
            dob,
            Age: age
        }));
    };

    const handleMaleAgeChange = (e) => {
        setIsMaleAgeManual(true);
        const { name, value, type } = e.target;


        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }
        setMaleForm(prev => ({
            ...prev,
            Age: e.target.value
        }));
    };


    const handleFemaleAgeChange = (e) => {
        setIsFemaleAgeManual(true);
        const { name, value, type } = e.target;


        if (type === "number" && value !== "" && Number(value) < 0) {
            return;
        }
        setFemaleForm(prev => ({
            ...prev,
            Age: e.target.value
        }));
    }

    // const handleMaleCalculationChange = (e) => {
    //     const { name, value } = e.target;


    //     setMaleForm(prev => {
    //         // Step 1: update changed field
    //         const updatedForm = {
    //             ...prev,
    //             [name]: value
    //         };

    //         // Step 2: calculate safely
    //         const volume = parseFloat(updatedForm.Semen_Volume) || 0;
    //         const concentration = parseFloat(updatedForm.Semen_Concentration) || 0;

    //         updatedForm.Total_Sperm_Count =
    //             volume > 0 && concentration > 0
    //                 ? (volume * concentration).toFixed(2)
    //                 : "";

    //         return updatedForm;
    //     });
    // };

    // const handleMotility = (e) => {
    //     const { name, value } = e.target;

    //     setMaleForm(prev => {
    //         const updatedForm = {
    //             ...prev,
    //             [name]: value
    //         };

    //         // const pr = parseFloat(updatedForm.Count_Motile_Sperm) || 0;
    //         const pr = parseFloat(updatedForm.Progressive_Motility_Rate) || 0;

    //         const np = parseFloat(updatedForm.NonP_Motility) || 0;
    //         // const Immotile = parseFloat(updatedForm.Immotile) || 0;

    //         updatedForm.Total_Motility =
    //             pr > 0 || np > 0 ? (pr + np).toFixed(2) : "";

    //         return updatedForm;
    //     });
    // };

    // const handleProgressiveMotileSperm = (e) => {
    //     const { name, value } = e.target;

    //     setMaleForm(prev => {
    //         const updatedForm = {
    //             ...prev,
    //             [name]: value
    //         };

    //         const motilityRate =
    //             parseFloat(updatedForm.Progressive_Motility_Rate) || 0;

    //         const totalSpermCount =
    //             parseFloat(updatedForm.Total_Sperm_Count) || 0;

    //         updatedForm.Count_Motile_Sperm =
    //             motilityRate > 0 && totalSpermCount > 0
    //                 ? ((motilityRate / 100) * totalSpermCount).toFixed(2)
    //                 : "";

    //         return updatedForm;
    //     });
    // };






    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token || !male_id) return;

        axios.get(`${API_URL}/partner_details_data_id_wise/${male_id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(res => {
                const data = res.data.partner_data;

                if (data?.male) {
                    setMaleForm(prev => ({
                        ...prev,
                        ...data.male,
                        pmid: data.male?.pmid,
                        sample_master_id: data.male?.sample_master_id
                    }));
                }

                if (data?.female) {
                    setFemaleForm(prev => ({
                        ...prev,
                        ...data.female,
                        pfid: data.female?.pfid
                    }));
                }


                setMaleHormonalRows(data.male_hormonal || []);
                setFemaleHormonalRows(data.female_hormonal || []);
            })
            .catch(console.error);

    }, [male_id]);


    ////////////////////////////post male data api through ///////////////////////////////


    const submitMaleData = async () => {
        const token = localStorage.getItem("token");

        const maleId = maleForm.pmid;

        if (!maleId) {
            // alert("male ID missing");

            setErrorMsg("male ID missing");

            setTimeout(() => setErrorMsg(""), 1000);
            return;
        }
        const payload = {
            male: maleForm,
            hormonal_assay: maleHormonalRows
        };

        await axios.put(
            `${API_URL}/male-partner/${maleId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        // alert("Male data updated successfully");

        setSuccessMsg("Male data updated successfully");
        setErrorMsg("");

        setTimeout(() => setSuccessMsg(""), 1000);



    };





    const submitFemaleData = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem("token");

            const femaleId = femaleForm.pfid;

            if (!femaleId) {
                // alert("Female ID missing");
                setErrorMsg("Female ID missing");

                setTimeout(() => setErrorMsg(""), 1000);
                return;
            }

            const filteredRows = femaleHormonalRows.filter(
                r =>
                    r.assay_date ||
                    r.FSH ||
                    r.LH ||
                    r.TSH ||
                    r.Prolactin
            );

            const payload = {
                female: femaleForm,
                hormonal_assay: filteredRows
            };

            await axios.put(
                `${API_URL}/female-partner/${femaleId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            // alert("Female partner updated successfully");
            // navigate("/Patient_report_sample_id_wise");

            setSuccessMsg("Female partner updated successfully");
            setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);


        } catch (error) {
            console.error("Female update error:", error);
            // alert("Failed to update female data");
            setErrorMsg("Failed to update female data");

            setTimeout(() => setErrorMsg(""), 1000);
        }
    };

    return (
        <div>
            <div className="text-end">
                <Link to={`/clinical-profile/${maleForm.sample_master_id}`}>
                    <Button variant="warning" className="px-3 me-3" style={{ fontWeight: "600" }}>
                        Clinical Profile
                    </Button>
                </Link>

                <Link to={`/molecular-profile/${maleForm.sample_master_id}`}>
                    <Button variant="warning" className="px-3" style={{ fontWeight: "600" }}>
                        Molecular Profile
                    </Button>
                </Link>
            </div>




            <h4><b>Update Partner Details</b></h4>
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}

            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
                <Tab eventKey="male" title="Male">

                    <Update_MaleForm form={maleForm} handleFormChange={handleMaleChange} onSubmit={submitMaleData} rows={maleHormonalRows}
                        setRows={setMaleHormonalRows} onDobChange={handleMaleDobChange} handleMaleAgeChange={handleMaleAgeChange} />
                </Tab>

                <Tab eventKey="female" title="Female">

                    <Update_Female_Details form={femaleForm} handleFormChange={handleFemaleChange} rows={femaleHormonalRows}
                        setRows={setFemaleHormonalRows} onSubmit={submitFemaleData} onDobChange={handleFemaleDobChange} handleFemaleAgeChange={handleFemaleAgeChange} />
                </Tab>

                {/* <Tab eventKey="male" title="Male">

                    <Update_MaleForm form={maleForm} handleFormChange={handleMaleChange} onSubmit={submitMaleData} rows={maleHormonalRows}
                        setRows={setMaleHormonalRows} onDobChange={handleMaleDobChange} onCalculate={handleMaleCalculationChange} onMotile_total={handleProgressiveMotileSperm} total_motility={handleMotility} handleMaleAgeChange={handleMaleAgeChange} />
                </Tab>

                <Tab eventKey="female" title="Female">

                    <Update_Female_Details form={femaleForm} handleFormChange={handleFemaleChange} rows={femaleHormonalRows}
                        setRows={setFemaleHormonalRows} onSubmit={submitFemaleData} onDobChange={handleFemaleDobChange} handleFemaleAgeChange={handleFemaleAgeChange} />
                </Tab> */}

            </Tabs>

            <style>{`
       

                    /* Remove select arrow */
                    .no-select-icon {
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    background-image: none !important;
                    }       
                    }.unit-input .form-control {
    border-right: 0;
}

.unit-input .unit-text {
    background-color: #fff;
    border-left: 1px solid #ced4da;
    font-weight: 500;
    min-width: 80px;
    justify-content: center;
}



/* When a real value is selected */

/* Disabled option styling */
.form-select:valid {
  color: #000;
}
  .form-select option[disabled] {
  color: #9aa0a6;
}
.floating-btn {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background-color: #0d6efd;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 14px 22px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    z-index: 9999;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
}

.floating-btn:hover {
    background-color: #084298;
}


.floating-label {
  position: fixed;
  top: 50%;
  left: 1px;
  transform: translateY(-50%);

  background: linear-gradient(
    180deg,
    #ff5C4D   /* soft medical blue */ 
    
  ); 

  color: #3333BB;
   font-family: "Poppins", "Montserrat", "Segoe UI", sans-serif;
  padding: 14px 16px;
  border-radius: 10px;

  box-shadow:
    0 10px 25px rgba(30, 64, 175, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

  z-index: 1000;

  writing-mode: vertical-rl;
  text-orientation: mixed;

  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;

  backdrop-filter: blur(4px);
}

.percent-text {
  color: red;
}


      `}</style>
        </div>


    );
}

export default Update_Male_Details;
